import { render, staticRenderFns } from "./rental-info.vue?vue&type=template&id=67a92ed8&scoped=true&"
import script from "./rental-info.vue?vue&type=script&lang=js&"
export * from "./rental-info.vue?vue&type=script&lang=js&"
import style0 from "./rental-info.vue?vue&type=style&index=0&id=67a92ed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a92ed8",
  null
  
)

export default component.exports